const system_limit = {
    limit_exceeded: 'Atingiu o limite do sistema. Contacte o suporte para obter ajuda.',
};
export default Object.freeze(system_limit);
